import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useProgress } from "../context/ProgressContext";
import { STICKERS, unlockedCount } from "../data/stickers";
import { playJingle } from "../lib/chime";

// Watches the active child's bamboo and toasts when a new sticker unlocks.
const StickerUnlockWatcher = () => {
  const { activeChildId, bamboo } = useProgress();
  const navigate = useNavigate();
  const seen = useRef({}); // childId -> last known unlocked count

  useEffect(() => {
    if (!activeChildId) return;
    const count = unlockedCount(bamboo);
    const prev = seen.current[activeChildId];
    seen.current[activeChildId] = count;
    if (prev === undefined || count <= prev) return;
    const sticker = STICKERS[count - 1];
    playJingle();
    toast.success(`New sticker unlocked: ${sticker.name}!`, {
      description: `${bamboo} bamboo - open the sticker book to see it.`,
      action: { label: "Sticker book", onClick: () => navigate("/stickers") },
      duration: 7000,
    });
  }, [activeChildId, bamboo, navigate]);

  return null;
};

export default StickerUnlockWatcher;
